import { create } from 'zustand'

interface ConfirmationModalStore {
   isOpen: boolean
   title: string
   icon: string
   iconClassName: string
   openConfirmationModal: (config: {
      title: string
      icon?: string
      iconClassName?: string
   }) => void
   closeConfirmationModal: () => void
}

export const useConfirmationModalStore = create<ConfirmationModalStore>(
   (set) => ({
      isOpen: false,
      title: '',
      icon: 'Check',
      iconClassName: 'scale-[5] fill-white',
      openConfirmationModal: (config) =>
         set({
            isOpen: true,
            title: config.title,
            icon: config.icon || 'Check',
            iconClassName: config.iconClassName || 'scale-[5] fill-white',
         }),
      closeConfirmationModal: () => set({ isOpen: false }),
   })
)
